import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AppService } from 'src/app/service/app.service';

@Component({
  selector: 'app-derivative-sidebar',
  templateUrl: './derivative-sidebar.component.html',
  styleUrls: ['./derivative-sidebar.component.css']
})
export class DerivativeSidebarComponent implements OnChanges, OnInit {

  @Input() derivative: string;
  hiddenMenus: any = [];
  menuListFinal: any = [];
  currentMenu: string = "";

  constructor(private router: Router,
    private appService: AppService,
    private cdref: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.derivative.currentValue == "") {
      this.derivative = "/" + this.router.url.split("/")[1] + "/" + this.router.url.split("/")[2];
    }
    this.getMenusForDerivative();
  }

  ngOnInit(): void {
    this.derivative = "/" + this.router.url.split("/")[1] + "/" + this.router.url.split("/")[2];
    this.getMenusForDerivative();
  }

  getMenusForDerivative() {
    this.currentMenu = this.derivative;
    let menu = this.derivative.split("/")[2];
    this.appService.getUserMenusDerivative(0, menu).pipe(
      catchError((error: any) => {
        this.menuListFinal = [];
        this.cdref.detectChanges();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.menuListFinal = response.data[0]?.menusList;
          this.cdref.detectChanges();
        } else {
          this.menuListFinal = [];
          this.cdref.detectChanges();
        }
      }
    );

  }

  stopRedirection(event: MouseEvent) {
    event.stopPropagation();
  }
}
